import React, { useState } from "react";
import * as Icon from "react-feather";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import About from "./pages/About";

import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Notfound from "./pages/Notfound";
import Portfolios from "./pages/Portfolios";
import Videos from "./pages/Videos";
import Logos from "./pages/Logos";
import IdentidadeCorporativa from "./pages/IdentidadeCorporativa";
import Agenda from "./pages/Agenda";
import Livros from "./pages/Livros";
import Mascotes from "./pages/Mascotes";
import Revistas from "./pages/Revistas";

import Resumes from "./pages/Resumes";

function App() {
  const [lightMode, setLightMode] = useState(false); // Made it true if you want to load your site light mode primary

  lightMode
    ? document.body.classList.add("light")
    : document.body.classList.remove("light");

  const handleMode = () => {
    if (!lightMode) {
      setLightMode(true);
      document.body.classList.add("light");
    } else {
      setLightMode(false);
      document.body.classList.remove("light");
    }
  };

  return (
    <BrowserRouter>
      <div className="light-mode">
        <span className="icon">
          <Icon.Sun />
        </span>
        <button
          className={
            lightMode ? "light-mode-switch active" : "light-mode-switch"
          }
          onClick={() => handleMode()}
        ></button>
      </div>
      <Routes>
        <Route path="/" index element={<Home lightMode={lightMode} />} />
        <Route path="about" element={<About />} />
        <Route path="resume" element={<Resumes />} />
        <Route path="portfolios" element={<Portfolios />} />
        <Route path="videos" element={<Videos />} />
        <Route path="logos" element={<Logos />} />
        <Route path="identidade" element={<IdentidadeCorporativa />} />
        <Route path="livros" element={<Livros />} />
        <Route path="mascotes" element={<Mascotes />} />
        <Route path="revistas" element={<Revistas />} />
        <Route path="agendas" element={<Agenda />} />
       
        <Route path="contact" element={<Contact />} />
        <Route path="*" element={<Notfound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
